import { app } from '../../../../../app';
import { Controller } from './unshare-shared-notes.controller';

app.component('companyUserDirectoriesManageUserUnshareSharedNotes', {
    bindings: {
        notes: '<',
        accountsForCompanyUser: '<',
        userSharedServiceAccounts: '<',
        userSharedNotes: '<',
        companyId: '<',
        companyUser: '<',
    },
    controller: Controller,
    templateUrl: require('./unshare-shared-notes.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/unshare-shared-notes/unshare-shared-notes.component.js